class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.loadMore.bind(this));
  }

  loadMore(event) {
    event.preventDefault();
    if (this.getAttribute('aria-disabled') === 'true') return;

    const nextUrl = this.getAttribute('data-next-url');
    if (!nextUrl) return;

    this.setAttribute('aria-disabled', 'true');
    this.classList.add('loading');
    const spinner = this.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');

    fetch(nextUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        
        const newGrid = parsedHTML.getElementById('product-grid') || parsedHTML.querySelector('.collection-list');
        const currentGrid = document.getElementById('product-grid') || document.querySelector('.collection-list');
        
        if (newGrid && currentGrid) {
          const newProducts = newGrid.querySelectorAll(':scope > li');
          newProducts.forEach((product) => {
            currentGrid.appendChild(product);
          });
          
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(currentGrid);
          }
        }
        
        const newLoadMore = parsedHTML.querySelector('load-more-button');
        if (newLoadMore) {
          const newNextUrl = newLoadMore.getAttribute('data-next-url');
          if (newNextUrl) {
            this.setAttribute('data-next-url', newNextUrl);
            this.removeAttribute('aria-disabled');
            this.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          } else {
            this.remove();
          }
        } else {
          this.remove();
        }
      })
      .catch((error) => {
        console.error('Error loading more products:', error);
        this.removeAttribute('aria-disabled');
        this.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}
